(function () {
  var root = document.querySelector('[data-cmc]');
  if (!root || root.__cmcInit) return;
  root.__cmcInit = 1;
  var d = document;
  function T(k) { return (window.CM_I18N && window.CM_I18N[k]) || k; }
  var grid = root.querySelector('.cmc-grid');
  if (!grid) return;
  var items = [].slice.call(grid.children).map(function (li, i) {
    var ds = li.dataset;
    return {
      el: li, i: i,
      price: parseFloat(ds.price) || 0,
      disc: parseFloat(ds.disc) || 0,
      title: (ds.title || '').toLowerCase(),
      concern: (ds.concern || '').split(' ').filter(Boolean),
      type: (ds.type || '').split(' ').filter(Boolean),
      deal: (ds.deal || '').split(' ').filter(Boolean),
      line: ds.line || '',
      set: ds.set === '1',
      avail: ds.avail === '1'
    };
  });
  var cur = root.getAttribute('data-cur') || '';
  var GROUPS = ['concern', 'line', 'type', 'format', 'offer', 'deal'];
  var st = { concern: [], line: [], type: [], format: [], offer: [], deal: [], stock: false, min: null, max: null, sort: 'featured', view: 'grid' };
  var qs = function (s, c) { return (c || root).querySelector(s); };
  var qsa = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };
  var countEl = qs('[data-cmc-count]');
  var activeEl = qs('[data-cmc-active]');
  var emptyEl = qs('[data-cmc-empty]');
  var minI = qs('[data-cmc-min]'), maxI = qs('[data-cmc-max]');
  var panel = qs('[data-cmc-panel]'), overlay = qs('[data-cmc-overlay]');
  var total = items.length;

  function readURL() {
    var p = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) { var v = p.get(g); st[g] = v ? v.split(',').filter(Boolean) : []; });
    st.stock = p.get('stock') === '1';
    st.min = p.get('min') !== null && p.get('min') !== '' ? parseFloat(p.get('min')) : null;
    st.max = p.get('max') !== null && p.get('max') !== '' ? parseFloat(p.get('max')) : null;
    if (p.get('sort')) st.sort = p.get('sort');
    if (p.get('view')) st.view = p.get('view');
  }
  function writeURL() {
    var p = new URLSearchParams();
    GROUPS.forEach(function (g) { if (st[g].length) p.set(g, st[g].join(',')); });
    if (st.stock) p.set('stock', '1');
    if (st.min !== null) p.set('min', st.min);
    if (st.max !== null) p.set('max', st.max);
    if (st.sort !== 'featured') p.set('sort', st.sort);
    if (st.view !== 'grid') p.set('view', st.view);
    var q = p.toString();
    try { history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '')); } catch (e) {}
  }
  function has(arr, list) { return list.some(function (v) { return arr.indexOf(v) > -1; }); }
  function ok(it, skip) {
    if (skip !== 'concern' && st.concern.length && !has(it.concern, st.concern)) return false;
    if (skip !== 'line' && st.line.length && st.line.indexOf(it.line) < 0) return false;
    if (skip !== 'type' && st.type.length && !has(it.type, st.type)) return false;
    if (skip !== 'deal' && st.deal.length && !has(it.deal, st.deal)) return false;
    if (skip !== 'format' && st.format.length && st.format.indexOf(it.set ? 'set' : 'single') < 0) return false;
    if (skip !== 'offer' && st.offer.length) {
      var o = st.offer.some(function (v) { return v === 'sale' ? it.disc > 0 : v === 'deal30' ? it.disc >= 30 : false; });
      if (!o) return false;
    }
    if (skip !== 'stock' && st.stock && !it.avail) return false;
    if (skip !== 'price') {
      if (st.min !== null && it.price < st.min) return false;
      if (st.max !== null && it.price > st.max) return false;
    }
    return true;
  }
  function optMatch(it, g, v) {
    if (g === 'concern') return it.concern.indexOf(v) > -1;
    if (g === 'line') return it.line === v;
    if (g === 'type') return it.type.indexOf(v) > -1;
    if (g === 'deal') return it.deal.indexOf(v) > -1;
    if (g === 'format') return (it.set ? 'set' : 'single') === v;
    if (g === 'offer') return v === 'sale' ? it.disc > 0 : it.disc >= 30;
    return false;
  }
  function labelFor(g, v) {
    var inp = qs('input[data-g="' + g + '"][value="' + v + '"]');
    return inp ? inp.closest('label').querySelector('.cmc-lbl').textContent.trim() : v;
  }
  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
  function sortItems(list) {
    var s = st.sort;
    return list.slice().sort(function (a, b) {
      if (s === 'price-asc') return a.price - b.price || a.i - b.i;
      if (s === 'price-desc') return b.price - a.price || a.i - b.i;
      if (s === 'disc-desc') return b.disc - a.disc || a.i - b.i;
      if (s === 'title-asc') return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
      return a.i - b.i;
    });
  }
  function chips() {
    var out = [];
    GROUPS.forEach(function (g) { st[g].forEach(function (v) { out.push({ g: g, v: v, t: labelFor(g, v) }); }); });
    if (st.stock) out.push({ g: 'stock', v: '1', t: T('In stock') });
    if (st.min !== null || st.max !== null) {
      var t = st.min !== null && st.max !== null ? fmt(st.min) + ' - ' + fmt(st.max) : st.min !== null ? T('From') + ' ' + fmt(st.min) : T('Up to') + ' ' + fmt(st.max);
      out.push({ g: 'price', v: '', t: t + ' ' + cur });
    }
    activeEl.innerHTML = '';
    out.forEach(function (c) {
      var s = d.createElement('span');
      s.className = 'cmc-tag';
      s.appendChild(d.createTextNode(c.t));
      var b = d.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', T('Remove filter') + ' ' + c.t); b.innerHTML = '&times;';
      b.setAttribute('data-rm-g', c.g); b.setAttribute('data-rm-v', c.v);
      s.appendChild(b);
      activeEl.appendChild(s);
    });
    if (out.length > 1) {
      var all = d.createElement('button');
      all.type = 'button'; all.className = 'cmc-tag cmc-tag--all'; all.textContent = T('Clear all'); all.setAttribute('data-cmc-clear', '');
      activeEl.appendChild(all);
    }
    var fb = qs('[data-cmc-fbtn]');
    if (fb) { fb.classList.toggle('has-n', out.length > 0); fb.querySelector('i').textContent = out.length; }
    return out.length;
  }
  function apply() {
    var shown = sortItems(items.filter(function (it) { return ok(it); }));
    var frag = d.createDocumentFragment();
    items.forEach(function (it) { it.el.hidden = true; });
    shown.forEach(function (it) { it.el.hidden = false; frag.appendChild(it.el); });
    grid.appendChild(frag);
    items.forEach(function (it) { if (it.el.hidden) grid.appendChild(it.el); });
    countEl.innerHTML = '<b>' + shown.length + '</b> <span>' + T('of {n} products').replace('{n}', total) + '</span>';
    emptyEl.classList.toggle('is-on', shown.length === 0);
    qsa('.cmc-opt input').forEach(function (inp) {
      var g = inp.getAttribute('data-g'), v = inp.value;
      if (g === 'stock') return;
      var n = items.filter(function (it) { return ok(it, g) && optMatch(it, g, v); }).length;
      var lab = inp.closest('label');
      lab.querySelector('.cmc-n').textContent = n;
      lab.classList.toggle('is-zero', n === 0 && !inp.checked);
    });
    var sc = qs('[data-cmc-stockcount]');
    if (sc) sc.textContent = items.filter(function (it) { return ok(it, 'stock') && it.avail; }).length;
    qsa('.cmc-opt input').forEach(function (inp) {
      var g = inp.getAttribute('data-g');
      inp.checked = g === 'stock' ? st.stock : st[g].indexOf(inp.value) > -1;
    });
    qsa('[data-cmc-preset]').forEach(function (b) {
      var a = b.getAttribute('data-cmc-preset').split('-');
      var mn = a[0] === '' ? null : parseFloat(a[0]), mx = a[1] === '' ? null : parseFloat(a[1]);
      b.classList.toggle('is-on', mn === st.min && mx === st.max);
    });
    if (minI) minI.value = st.min !== null ? st.min : '';
    if (maxI) maxI.value = st.max !== null ? st.max : '';
    var sortEl = qs('[data-cmc-sort]'); if (sortEl) sortEl.value = st.sort;
    grid.setAttribute('data-view', st.view);
    qsa('[data-cmc-view]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-cmc-view') === st.view); });
    var n = chips();
    var ap = qs('[data-cmc-apply]'); if (ap) ap.textContent = shown.length === 1 ? T('Show 1 result') : T('Show {n} results').replace('{n}', shown.length);
    writeURL();
  }
  function toggle(arr, v) { var i = arr.indexOf(v); if (i > -1) arr.splice(i, 1); else arr.push(v); }
  function clearAll() { GROUPS.forEach(function (g) { st[g] = []; }); st.stock = false; st.min = null; st.max = null; apply(); }
  function openPanel(o) {
    if (!panel) return;
    panel.classList.toggle('is-open', o);
    overlay.classList.toggle('is-on', o);
    d.documentElement.classList.toggle('cmc-lock', o);
  }
  root.addEventListener('change', function (e) {
    var inp = e.target.closest('.cmc-opt input');
    if (inp) {
      var g = inp.getAttribute('data-g');
      if (g === 'stock') st.stock = inp.checked; else toggle(st[g], inp.value);
      apply(); return;
    }
    if (e.target.matches('[data-cmc-min],[data-cmc-max]')) {
      var a = parseFloat(minI.value), b = parseFloat(maxI.value);
      st.min = isNaN(a) ? null : a; st.max = isNaN(b) ? null : b;
      apply(); return;
    }
    if (e.target.matches('[data-cmc-sort]')) { st.sort = e.target.value; apply(); }
  });
  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-cmc-preset]'))) {
      var a = t.getAttribute('data-cmc-preset').split('-');
      var mn = a[0] === '' ? null : parseFloat(a[0]), mx = a[1] === '' ? null : parseFloat(a[1]);
      if (mn === st.min && mx === st.max) { st.min = null; st.max = null; } else { st.min = mn; st.max = mx; }
      apply(); return;
    }
    if ((t = e.target.closest('[data-rm-g]'))) {
      var g = t.getAttribute('data-rm-g'), v = t.getAttribute('data-rm-v');
      if (g === 'stock') st.stock = false; else if (g === 'price') { st.min = null; st.max = null; } else toggle(st[g], v);
      apply(); return;
    }
    if (e.target.closest('[data-cmc-clear]')) { clearAll(); return; }
    if ((t = e.target.closest('[data-cmc-view]'))) { st.view = t.getAttribute('data-cmc-view'); apply(); return; }
    if (e.target.closest('[data-cmc-fbtn]')) { openPanel(true); return; }
    if (e.target.closest('[data-cmc-close],[data-cmc-apply],[data-cmc-overlay]')) { openPanel(false); return; }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') openPanel(false); });
  readURL();
  apply();
})();